var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-2 py-1 pl-2",attrs:{"no-body":""}},[_c('vue-apex-charts',{ref:"grafico",staticClass:"chart",attrs:{"type":"line","height":"350","width":"98%","options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }